import { render } from "./UserProfileOverviewSection.vue?vue&type=template&id=4ede40e5"
import script from "./UserProfileOverviewSection.vue?vue&type=script&lang=js"
export * from "./UserProfileOverviewSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__